import { Component, OnInit } from '@angular/core';
import { BbTableService, TableRow } from '../../../services/bb-table.service';
import { CustomFieldsService } from '../../../services/custom-fields.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'bb-solr-query-documentation',
	templateUrl: './bb-solr-query-documentation.component.html',
	styleUrls: ['./bb-solr-query-documentation.component.scss'],
	providers: [BbTableService]
})

export class BbSolrQueryDocumentationComponent implements OnInit {
	solrFields: any[];
	customFields: any[];
	private subscriptions = new Subscription();

	constructor(private customFieldsService: CustomFieldsService,
		private bbTableService: BbTableService) {

		this.subscriptions.add(this.bbTableService.rowsRetrievedObservable.subscribe((rows: TableRow[]) => {
			if (rows) {
				this.solrFields = rows;
			}
		}));
	}

	ngOnInit() {
		this.customFields = this.customFieldsService.getCustomFields('mediaclip');
		this.solrFields = [];
		this.makeSolrFieldsTable();
		this.bbTableService
			.setLimit(100)
			.setConfigurable(false)
			.setData(this.solrFields)
			.getRows();
	}

	makeSolrFieldsTable() {

		this.solrFields.push(
			{
				label: 'ID',
				type: 'string',
				value: 'id',
				description: ''
			},
			{
				label: 'TITLE',
				type: 'string',
				value: 'title',
				description: ''
			},
			{
				label: 'DURATION',
				type: 'int',
				value: 'length',
				description: 'FIELD_DESCRIPTION_LENGTH'
			},
			{
				label: 'VIEWS',
				type: 'int',
				value: 'views',
				description: 'FIELD_DESCRIPTION_VIEWS'
			},
			{
				label: 'TAG',
				type: 'multistring',
				value: 'cat',
				description: ''
			},
			{
				label: 'TRANSCODING_FINISHED',
				type: 'string',
				value: 'transcodingFinished',
				description: 'FIELD_DESCRIPTION_TRANSCODING_FINISHED'
			},
			{
				label: 'USER_ID',
				type: 'string',
				value: 'userid',
				description: 'FIELD_DESCRIPTION_USER_ID'
			},
			{
				label: 'DEEP_LINK',
				type: 'string',
				value: 'deeplink',
				description: 'FIELD_DESCRIPTION_DEEP_LINK'
			},
			{
				label: 'GENERATED_DEEP_LINK',
				type: 'string',
				value: 'gendeeplink',
				description: 'FIELD_DESCRIPTION_GENERATED_DEEP_LINK'
			},
			{
				label: 'DESCRIPTION',
				type: 'string',
				value: 'description',
				description: ''
			},
			{
				label: 'STATUS',
				type: 'string',
				value: 'status',
				description: 'FIELD_DESCRIPTION_STATUS'
			},
			{
				label: 'COPYRIGHT',
				type: 'string',
				value: 'copyright',
				description: ''
			},
			{
				label: 'MEDIATYPE',
				type: 'string',
				value: 'mediatype',
				description: 'FIELD_DESCRIPTION_MEDIATYPE'
			},
			{
				label: 'SOURCETYPE',
				type: 'string',
				value: 'sourcetype',
				description: 'FIELD_DESCRIPTION_SOURCETYPE'
			},
			{
				label: 'AUTHOR',
				type: 'string',
				value: 'author',
				description: ''
			},
			{
				label: 'ORIGINAL_FILENAME',
				type: 'string',
				value: 'originalfilename',
				description: 'FIELD_DESCRIPTION_ORIGINAL_FILENAME'
			},
			{
				label: 'MODIFIED_DATE',
				type: 'string',
				value: 'modifieddate',
				description: ''
			},
			{
				label: 'CREATED_DATE',
				type: 'string',
				value: 'createddate',
				description: ''
			},
			{
				label: 'SOURCE_ID',
				type: 'string',
				value: 'sourceid',
				description: 'FIELD_DESCRIPTION_SOURCE_ID'
			});

		for (let i = 0; i < this.customFields.length; i++) {
			this.solrFields.push({
				label: this.customFields[i].label,
				type: this.customFields[i].type,
				value: this.customFields[i].name,
				description: 'CUSTOM_METADATA_FIELD'
			});
		}
	}
}
